import React from 'react';

// Placeholder for actual SVG icons
const PlaceholderIcon = ({ className = '' }) => (
  <svg className={`w-10 h-10 md:w-12 md:h-12 text-accent ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

function HowItWorks() {
  return (
    <section className="py-16 md:py-20 lg:py-28 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-2xl sm:text-3xl text-center font-bold mb-10 md:mb-16 text-primary">Get Started in Minutes</h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-10 lg:gap-16 max-w-5xl mx-auto mb-10 md:mb-16">
          {/* Step 1 */}
          <div className="text-center">
            <PlaceholderIcon className="mx-auto mb-4 md:mb-5" />
            <h3 className="mb-2 md:mb-3 font-bold text-primary">1. Enter Invoice Details</h3>
            <p className="text-primary-light text-sm">Quickly add your client's email, invoice amount, and due date.</p>
          </div>
          {/* Step 2 */}
          <div className="text-center">
            <PlaceholderIcon className="mx-auto mb-4 md:mb-5" />
            <h3 className="mb-2 md:mb-3 font-bold text-primary">2. Bot Sends Reminders</h3>
            <p className="text-primary-light text-sm">We automatically send friendly email nudges before and after the due date.</p>
          </div>
          {/* Step 3 */}
          <div className="text-center sm:col-span-2 md:col-span-1">
            <PlaceholderIcon className="mx-auto mb-4 md:mb-5" />
            <h3 className="mb-2 md:mb-3 font-bold text-primary">3. Mark as Paid</h3>
            <p className="text-primary-light text-sm">Click one button when the payment arrives to stop reminders. That's it!</p>
          </div>
        </div>
        
        {/* Email Template Preview */}
        <div className="mb-12 md:mb-16">
          <h3 className="text-xl text-center font-semibold mb-6 text-primary">Professional, Friendly Reminders Your Clients Will Appreciate</h3>
          <div className="max-w-xl mx-auto rounded-lg shadow-lg overflow-hidden border border-gray-200">
            <img 
              src="/images/dash2.png" 
              alt="PolitePay Email Template" 
              className="w-full h-auto"
            />
          </div>
          <p className="text-center text-primary-light mt-4 text-sm max-w-md mx-auto">Our templates are designed to maintain good client relationships while gently nudging for payment.</p>
        </div>
        
        <div className="max-w-md mx-auto bg-gray-50 p-4 md:p-6 rounded-lg shadow-sm border border-gray-100">
          <ul className="space-y-3 text-primary">
            <li className="flex items-center">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-accent mr-3 flex-shrink-0" />
              <span>No complicated setup required</span>
            </li>
            <li className="flex items-center">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-accent mr-3 flex-shrink-0" />
              <span>No software to install</span>
            </li>
            <li className="flex items-center">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-accent mr-3 flex-shrink-0" />
              <span>Works with your existing invoicing method (PDF, Word, Email)</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

// Simple Check Icon Component
const CheckIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
);

export default HowItWorks; 